import {
  getNestedValue,
  LOCATION_DETAILS,
  ROOM_INFORMATION,
} from '@exam-center/exam-location-management';
import { useNavigate } from '@exam-center/router';
import { Divider, Flex, PaperSection, SectionTitle, Text } from '@shared/components';

import { ExamRoomDetailsBar } from '../../components';
import { useExamLocationDetails } from '../../providers';

export default function ExamCenterLocationDetails() {
  const navigate = useNavigate();
  const { roomDetails, examCenterCode } = useExamLocationDetails();

  const roomData = {
    room: {
      name: roomDetails.name ?? '-',
      building: roomDetails.building?.nameTh ?? '-',
      floor: roomDetails.floor ?? '-',
      roomNumber: roomDetails.roomNumber || '-',
      seatCount: roomDetails.seat ?? '-',
      location: {
        province: roomDetails.building?.location.province?.nameTh || '-',
        nameTh: roomDetails.building?.location.nameTh || '-',
        nameEn: roomDetails.building?.location.nameEn || '-',
        building: roomDetails.building?.nameTh || '-',
      },
    },
  };

  const handlePhysicalInfoClick = () => {
    navigate('/:examCenterCode/exam-location/locations/:roomId/physical-info', {
      params: {
        roomId: roomDetails.id,
        examCenterCode,
      },
    });
  };

  const handleComputerInfoClick = () => {
    navigate('/:examCenterCode/exam-location/locations/:roomId/computer-info', {
      params: {
        roomId: roomDetails.id,
        examCenterCode,
      },
    });
  };

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(6),
        p: theme.spacing(6),
      })}
    >
      <PaperSection title='ข้อมูลสถานที่สอบ'>
        <Flex
          sx={(theme) => ({
            flexDirection: 'column',
            gap: theme.spacing(6),
            p: theme.spacing(6),
          })}
        >
          <SectionTitle title='Location Details' />

          {LOCATION_DETAILS.map((detail) => (
            <Flex
              key={detail.label}
              sx={(theme) => ({
                gap: theme.spacing(6),
              })}
            >
              <Text
                variant='body1Semibold'
                sx={{
                  maxWidth: '240px',
                  width: '50%',
                }}
              >
                {detail.label}
              </Text>

              <Flex
                sx={(theme) => ({
                  flexDirection: 'column',
                  gap: theme.spacing(4),
                })}
              >
                {detail.value.map((accessor, index) => (
                  <Text key={index}>{String(getNestedValue(roomData, accessor) || '')}</Text>
                ))}
              </Flex>
            </Flex>
          ))}
        </Flex>
      </PaperSection>

      <PaperSection title='ข้อมูลห้องสอบ'>
        <Flex
          sx={(theme) => ({
            flexDirection: 'column',
            gap: theme.spacing(6),
            p: theme.spacing(6),
          })}
        >
          <SectionTitle title='Room Information' />

          {ROOM_INFORMATION.map((information) => (
            <Flex
              key={information.label}
              sx={(theme) => ({
                gap: theme.spacing(6),
              })}
            >
              <Text
                variant='body1Semibold'
                sx={{
                  maxWidth: '240px',
                  width: '50%',
                }}
              >
                {information.label}
              </Text>
              <Flex
                sx={(theme) => ({
                  flexDirection: 'column',
                  gap: theme.spacing(4),
                })}
              >
                {information.value.map((accessor, index) => (
                  <Text key={index}>{String(getNestedValue(roomData, accessor) || '')}</Text>
                ))}
              </Flex>
            </Flex>
          ))}

          <Divider />

          <SectionTitle title='Room Details' />

          <ExamRoomDetailsBar
            examRoomDetailType='physical-info'
            onButtonClick={handlePhysicalInfoClick}
          />
          <ExamRoomDetailsBar
            examRoomDetailType='computer-info'
            onButtonClick={handleComputerInfoClick}
          />
        </Flex>
      </PaperSection>
    </Flex>
  );
}
